import React from "react";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import request from "src/utils/request";

const KnowledgebaseIconLink = ({ name }) => {
    const DocumentationLinks = {
        "sprint-breakdown": "https://docs.adadot.com/",
        commits: "https://docs.adadot.com/",
        deployments: "https://docs.adadot.com",
        pipelines: "https://docs.adadot.com",
        "merge-requests": "https://docs.adadot.com/Dashboard/Personal/Work/prs/",
        reviews: "https://docs.adadot.com",
        "time-of-communications": "https://docs.adadot.com",
        "time-spent-communicating": "https://docs.adadot.com",
        "most-used-channels": "https://docs.adadot.com",
        "public-private": "https://docs.adadot.com",
        "hours-in-meetings": "https://docs.adadot.com",
        "meetings-breakdown": "https://docs.adadot.com",
        "frequent-collaborators": "https://docs.adadot.com",
        "long-hours": "https://docs.adadot.com",
        fragmentation: "https://docs.adadot.com",
        "out-of-hours": "https://docs.adadot.com",
        "focus-time": "https://docs.adadot.com",
        "time-to-review": "https://docs.adadot.com",
        upskilling: "https://docs.adadot.com/",
        benchmarks: "https://docs.adadot.com/",
    };

    const iconOnClick = async () => {
        try {
            await request(`/api/users/me/achievements`, {
                method: "POST",
                body: JSON.stringify(["visitKnowledgeBase"]),
            });
        } catch (error) {
            //
        }
    };

    return (
        <IconButton
            size="small"
            href={DocumentationLinks[name]}
            onClick={() => iconOnClick()}
            aria-label="see knowledge base"
            color="secondary"
            target="_blank"
        >
            <InfoIcon fontSize="small" />
        </IconButton>
    );
};

export default KnowledgebaseIconLink;
